import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import "./Dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import { selectProfile } from "../../store/slices/profile-slice";
import { fetchProfile } from "../../store/thunks/fetch-profile-thunk";
import ProfileImage from "../Images/profile.png";
import ApplicationImage from "../Images/application.png";

export const Dashboard = () => {
    const navigate = useNavigate();
    const profile = useSelector(selectProfile); //returns that state of profile
    const profileStatus = useSelector((state) => state.profile.status);
    const dispatch = useDispatch();

    let data = {
        firstName: profile.firstName ? profile.firstName : "",
        middleName: profile.middleName ? profile.middleName : "",
        lastName: profile.lastName ? profile.lastName : "",
    };

    let { firstName, middleName, lastName } = data;
    const middleInitial = middleName.charAt(0) ? middleName.charAt(0) : "";
    useEffect(() => {
        if (profileStatus === "idle") {
            dispatch(fetchProfile());
        }
    }, [dispatch, profileStatus]);

    return (
        <>
            <Row xs={12} className="dashboardWelcome">
                    <Col className="text-center">
                        <h2 className="fw-bolder mt-5 mb-5 dashboard-font-customize animate__animated animate__fadeIn">
                            Welcome, {firstName} {lastName}
                        </h2>
                    </Col>
            </Row>
            <Row
                xs={12}
                className="bg-body-secondary rounded-3 p-4 shadow-lg border border-black border-1 border-opacity-10"
            >
                <Col
                    xs={12}
                    xl={6}
                    className="d-flex justify-content-center justify-content-xl-end  mt-2 py-2"
                >
                    <Button
                        className="background-card text-black fw-bold rounded-3 shadow border-0 m-2"
                        variant=""
                        size="lg"
                        onClick={() =>
                            navigate("/profileCard", {
                                replace: true,
                            })
                        }
                    >
                        <img
                            src={ProfileImage}
                            alt="no image"
                            className="icon-position"
                        ></img>
                        USER PROFILE
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </Button>
                </Col>
                {/* <Col className="m-4">Click here to complete your profile and view all the information you have on file.</Col> */}
                <Col
                    xs={12}
                    xl={6}
                    className="d-flex justify-content-center justify-content-xl-start mt-2 py-2"
                >
                    <Button
                        className="background-card text-black fw-bold rounded-3 shadow border-0 m-2"
                        variant=""
                        size="lg"
                        onClick={() =>
                            navigate("/application", {
                                replace: true,
                            })
                        }
                    >
                        <img
                            src={ApplicationImage}
                            alt="no image"
                            className="icon-position"
                        ></img>
                        APPLICATION STATUS
                    </Button>
                </Col>
            </Row>
        </>
    );
};
